import { faImage } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from 'antd';
import React, { useEffect, useRef, useState } from 'react';

const { Text } = Typography;

interface ImageUploaderProps {
  src: string;
  text: string;
  onSetImage?: (image: string) => void;
}

const ImageUploader: React.FC<ImageUploaderProps> = ({ src, text, onSetImage }) => {
  const [imageSrc, setImageSrc] = useState<string>(src);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Image = reader.result as string;
        setImageSrc(base64Image);
        
        onSetImage?.(base64Image);
      };
      reader.readAsDataURL(file);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current?.click();
  };

  useEffect(() => {
    setImageSrc(src)
  }, [src])

  if (src.includes('undefined')) {
    return null
  }

  return (
    <div className="image-uploader" onClick={triggerFileInput} style={{ position: 'relative', width: '405px', height: '250px', cursor: 'pointer' }}>
      <img
        src={imageSrc}
        alt="Selected or Placeholder"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: '4px',
          border: '1px solid #ccc',
        }}
      />
      <div className="upload-overlay" style={{ 
        position: 'absolute', 
        bottom: 0, 
        width: '100%', 
        display: 'flex', 
        alignItems: 'center', 
        gap: '5px', 
        padding: '10px', 
        backgroundColor: '#11a983', 
        color: 'white' 
      }}>
        <FontAwesomeIcon icon={faImage} />
        <Text style={{ color: 'white' }}>{text}</Text>
      </div>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={handleImageUpload}
      />
    </div>
  );
};

export default ImageUploader;
